import React, { MouseEvent, ChangeEvent } from 'react'
import styled from 'styled-components'
import { Checkbox, Form, Icon, Input, Segment, InputOnChangeData, Label } from 'semantic-ui-react'

import EmptyState from 'shared/components/EmptyState'
import { NewTabLink } from 'components/NewTabLink'
import { UserCheckboxItem } from './UserCheckboxItem'
import { UserAccess } from './index'

const emptyUsersMessage = (
  <EmptyState
    icon={<Icon className="far fa-users" />}
    callToAction={
      <NewTabLink to="/settings/users/">Edit user roles or invite more people.</NewTabLink>
    }
  >
    Your account doesn't have any managers or collaborators yet.
  </EmptyState>
)

const CheckboxOptions = styled.div`
  margin: 16px 0;
  color: var(--ss-link-color);

  a {
    cursor: pointer;
  }
`

type Props = {
  clearAllOptions: (event: MouseEvent) => void
  currentUserId: number | null
  handleSearchChange: (event: ChangeEvent, data: InputOnChangeData) => void
  onCheckboxChange: (user: UserAccess) => void
  selectAllOptions: (event: MouseEvent) => void
  users: UserAccess[]
  hasUsers: boolean
}
export default function CustomUserAccessBox({
  clearAllOptions,
  currentUserId,
  handleSearchChange,
  onCheckboxChange,
  selectAllOptions,
  users,
  hasUsers,
}: Props) {
  if (!hasUsers) {
    return (
      <Form>
        <Segment>
          <Input
            fluid
            icon="far fa-magnifying-glass"
            iconPosition="left"
            className="search"
            placeholder="Search users"
            disabled
          />
          <Form.Field>{emptyUsersMessage}</Form.Field>
        </Segment>
      </Form>
    )
  }

  return (
    <Form>
      <Segment>
        <Input
          fluid
          icon="far fa-magnifying-glass"
          iconPosition="left"
          className="search"
          placeholder="Search users"
          onChange={handleSearchChange}
        />

        {users.length > 0 ? (
          <React.Fragment>
            <CheckboxOptions>
              <a onClick={selectAllOptions}>Select all</a>
              {` · `}
              <a onClick={clearAllOptions}>Deselect all</a>
            </CheckboxOptions>
            {users.map((user, index) => {
              return (
                <Form.Field key={index}>
                  <Checkbox
                    label={{
                      children: <UserCheckboxItem user={user} currentUserId={currentUserId} />,
                    }}
                    checked={user.has_permission}
                    onChange={() => onCheckboxChange(user)}
                  />
                  <Label basic className="ml2">
                    {user.role}
                  </Label>
                </Form.Field>
              )
            })}
          </React.Fragment>
        ) : (
          <Form.Field>{emptyUsersMessage}</Form.Field>
        )}
      </Segment>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/SurveyAccessFormModal/CustomUserAccessBox.tsx